import { useGetPolicies } from './useGetPolicies';

export const useHasPolicy = (policy: string): boolean => {
  const { data } = useGetPolicies({ enabled: !!policy });

  return Array.isArray(data?.policies) && data.policies.includes(policy);
};
